import { createApp } from '@app/adapters/create-app'

import DocumentPreviewPartsViewer from '../sections/document-preview-parts-viewer.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='document-preview-viewer']").each(function () {
    const data = this.dataset

    createApp(DocumentPreviewPartsViewer, {
      previews: JSON.parse(data.previews),
      ownerId: data.ownerId,
      ownerType: data.ownerType,
      enableAnnotations: data.enableAnnotations === 'true',
      enableAnnotationsToolbar: data.enableAnnotationsToolbar === 'true',
      enableAiProposalDrawer: data.enableAiProposalDrawer === 'true',
      disableMouseWheelZoom: data.disableMouseWheelZoom === 'true',
    }).mount(this)
  })
})
